// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .rfq-align-right {
  text-align: right;
}
::ng-deep html, ::ng-deep body {
  height: 100%; /* Ensure that ancestors have defined height */
}
::ng-deep .flex-unset {
  flex: unset !important;
}
::ng-deep .display-flex {
  display: flex;
}
::ng-deep .text-align-center {
  text-align: center;
}
::ng-deep .flex-justify-center {
  justify-content: center;
  align-items: center;
}
::ng-deep .flex-align-center {
  align-items: center;
}
::ng-deep .img-container-80vw {
  min-width: 100px;
  min-height: 100px;
  width: 80vw;
}
::ng-deep ul.disc {
  list-style-type: disc;
}
::ng-deep ul.disc li {
  margin-left: 0.75rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/rfq/rfq.blocks.scss"],"names":[],"mappings":"AACC;EACC,iBAAA;AAAF;AAGC;EACC,YAAA,EAAA,8CAAA;AADF;AAIC;EACC,sBAAA;AAFF;AAKC;EACC,aAAA;AAHF;AAMC;EACC,kBAAA;AAJF;AAOC;EACC,uBAAA;EACA,mBAAA;AALF;AAQC;EACC,mBAAA;AANF;AASC;EACC,gBAAA;EACA,iBAAA;EACA,WAAA;AAPF;AAUC;EACC,qBAAA;AARF;AAUE;EACC,oBAAA;EACA,qBAAA;AARH","sourcesContent":["::ng-deep {\n\t.rfq-align-right {\n\t\ttext-align: right;\n\t}\n\n\thtml, body {\n\t\theight: 100%; /* Ensure that ancestors have defined height */\n\t}\n\n\t.flex-unset {\n\t\tflex: unset !important;\n\t}\n\n\t.display-flex {\n\t\tdisplay: flex;\n\t}\n\n\t.text-align-center {\n\t\ttext-align: center;\n\t}\n\n\t.flex-justify-center {\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.flex-align-center {\n\t\talign-items: center;\n\t}\n\n\t.img-container-80vw {\n\t\tmin-width: 100px;\n\t\tmin-height: 100px;\n\t\twidth: 80vw;\n\t}\n\n\tul.disc {\n\t\tlist-style-type: disc;\n\n\t\tli {\n\t\t\tmargin-left: .75rem;\n\t\t\tmargin-bottom: .5rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
